// extracted by mini-css-extract-plugin
export var videoBg = "styles-module--videoBg--e33cb";